import { ReactNode } from 'react';
import { AppHeaderComponent } from "../components/AppHeaderComponent/AppHeaderComponent";
import PageFooterComponent from '../components/DefaultLayout/PageFooterComponent';

interface PageLayoutProps {
    children: ReactNode;
}

export const PageLayout = ({ children }: PageLayoutProps) => {
    return (
        <div style={{
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <AppHeaderComponent/>
            <div style={{ flex: 1 }}>
                {children}
            </div>
            <PageFooterComponent />
        </div>
    );
};